const useGetPermissions = ({dispatch, setLoader}) => {
	const getPermissions = (async (token) => {
		if (!token) return;
		
		try {
			const baseUrl = `${process.env.API_URL}`;
			const url = new URL('backoffice/v1/permissions', baseUrl);
			
			const response = await fetch(url, {
				headers: { Authorization: `Bearer ${token}` },
			});
			const data = await response.json();

			dispatch({ type: 'SET_PERMISSIONS', payload: data?.data ?? [] });
		} catch (e) {
			console.log(e)
		} finally {
			setLoader(false)
		}
	});
	
	return { getPermissions };
};

export default useGetPermissions;